module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-8-93cf9ab8d1ba731846eca38f0ace9d1b.jpg";